const processChartData = (data, config, selectedObj, numberOfMonths) => {
  const seriesData = {};
  let highestRTimeStamp = 0;

  data.forEach((item) => {
    if (item.reportedTime) {
      const timestamp = Date.parse(item.reportedTime.replace('T', ' '));
      Object.keys(config.series).forEach((key) => {
        if (item[key] !== undefined) {
          if (!seriesData[key]) seriesData[key] = [];
          seriesData[key].push([timestamp, parseFloat(item[key])]);
        }
      });

      if (item.status === 'A') {
        highestRTimeStamp = Math.max(highestRTimeStamp, timestamp);
      }
    }
  });

  let selectedPoint = null;
  let min = null;
  let max = null;
  let limitPoint = null;

  if (selectedObj) {
    const dt = new Date(selectedObj.StartTime.replace('T', ' '));
    dt.setHours(dt.getHours() + 10);
    min = dt.getTime();
    max = dt.getTime();
    selectedPoint = Date.parse(selectedObj.StartTime.replace('T', ' '));
    limitPoint = selectedObj.limitToShow;
  }

  const zones = [{ value: highestRTimeStamp }, { dashStyle: 'dot' }];

  return {
    series: Object.keys(config.series).map((key) => ({
      data: seriesData[key] || [],
      color: config.colors[key],
      zones,
      name: config.labels[key],
    })),
    config: {
      xAxis: {
        min,
        max,
        plotLines: [
          {
            color: 'grey', // Color value
            value: selectedPoint, // Value of where the line will appear
            width: 1, // Width of the line
          },
        ],
      },
      yAxis: {
        title: {
          text: `Voltage (${config.units})`,
        },
        plotLines: [
          {
            value: limitPoint,
            color: 'grey',
            width: 1,
          },
        ],
      },
      rangeSelector: {
        selected: Number(numberOfMonths) === 6 ? 3 : 0,
      },
    },
  };
};

export default processChartData;
